<div class="ui-g profile-container">
	<div class="ui-g-3 profile-avatar-container">
		<div #avatar id="avatar" (click)="fileInput.click()"></div>
		<input #fileInput hidden="true" type="file" onclick="this.value=null" (change)="fileInputChange($event)" accept="image/*"/>
		<div class="profile-avatar-buttons">
			<button style="background: none;" (click)="fileInput.click()" mat-button matTooltip="Change photo"><mat-icon>camera_alt</mat-icon></button>
			<button style="background: none;" (click)="clearAvatar($event)" mat-button matTooltip="Remove photo"><mat-icon>cancel</mat-icon></button>
		</div>
		<p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" *ngIf="loading"></p-progressSpinner>
	</div>
	
	<div class="ui-g-9 profile-data-container">
		<div class="profile-data-scroll">
			<div class="ui-g" style="padding-bottom: 8px;">
				<div class="ui-g-4 ui-md-4">
					<label style="color:Gray;">Full Name:</label>
				</div>
				<div class="ui-g-8 ui-md-8">
					<label class="label-data-override">{{this.fullName}}</label>
				</div>
			</div>
			<div class="ui-g" style="padding-bottom: 8px;">
				<div class="ui-g-4 ui-md-4">
					<label style="color:Gray">User Name:</label>
				</div>
				<div class="ui-g-8 ui-md-8">
					<label class="label-data-override">{{this.userName}}</label>
				</div>
			</div>
			<div class="ui-g" style="padding-bottom: 8px;">
				<div class="ui-g-4 ui-md-4">
					<label style="color:Gray">Agency:</label>
				</div>
				<div class="ui-g-8 ui-md-8">
					<label class="label-data-override">{{this.agencyName}}</label>
				</div>
			</div>
			<div class="ui-g" style="padding-bottom: 8px;">
				<div class="ui-g-4 ui-md-4">
					<label style="color:Gray">Last Login:</label>
				</div>
				<div class="ui-g-8 ui-md-8">
					<label class="label-data-override">{{this.lastLogin}}</label>
				</div>
			</div>
			<div class="ui-g" style="padding-bottom: 0px; padding-top: 8px;">
				<div class="ui-g-12" style="text-align: left; margin-bottom: 5px;">
					<label style="font-weight: bold; font-size: 13px; color: #333;">Security</label>
				</div>
				<div class="ui-g-4 ui-md-4">
					<label style="color:Gray">Group(s):</label>
				</div>
				<div class="ui-g-8 ui-md-8">
					<span *ngIf="securityGroups && securityGroups.length > 0; else noGroups">
						<span class="profile-badge" *ngFor="let group of securityGroups">{{group.name}}</span>
					</span>
					<ng-template #noGroups>
						<label class="label-data-override" style="color: #999;">None assigned</label>
					</ng-template>
				</div>
			</div>
			<div class="ui-g" style="padding-bottom: 8px;" *ngIf="userLevelOverrides && userLevelOverrides.length > 0">
				<div class="ui-g-4 ui-md-4">
					<label style="color:Gray">User Overrides:</label>
				</div>
				<div class="ui-g-8 ui-md-8">
					<div class="overrides-table-container">
						<table>
							<tr *ngFor="let override of userLevelOverrides">
								<td>{{override.name}}</td>
								<td>{{override.rightType}}</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="buttonHolder">
	<button mat-button style="width: 85px;" class="dialog-button" matTooltip="Close window" (click)="doCancel()">CLOSE</button>
</div>

<style>
	.profile-badge {
		display: inline-block;
		background-color: #e8f4f8;
		color: #0066cc;
		padding: 5px 12px;
		border-radius: 12px;
		margin-right: 8px;
		margin-bottom: 6px;
		font-size: 11px;
		font-weight: 500;
		border: 1px solid #b3d9e8;
		white-space: nowrap;
	}
</style>
